<template>
<div style="width:400px;margin:0 auto;margin-top:30px;padding-top:10px">
             <v-text-field
                type="password"
                style="min-width:300px;width:400px;margin:0 auto;height:60px"
                label="Old Password"
                v-model="password"
                solo
                />
             <v-text-field
                type="password"
                style="min-width:300px;width:400px;margin:0 auto;height:60px"
                label="New Password"
                v-model="newpassword"
                solo
                />
            <v-text-field
                type="password"
                style="min-width:300px;width:400px;margin:0 auto;height:60px"
                label="Confirm Password"
                v-model="repassword"
                solo
                />
        <div style="width:100%;float:left">
            <v-btn color="primary" style="min-width:300px;width:400px;margin:0 auto;" @click="reset">Submit</v-btn>
        </div>
                <v-dialog
                v-model="proccess"
                persistent
                width="300">
                        <v-card
                        color="primary"
                        dark>
                                <v-card-text>Please wait
                                        <v-progress-linear
                                        indeterminate
                                        color="white"
                                        class="mb-0"
                                        />
                                        
                        </v-card-text>
                </v-card>
                 </v-dialog>
</div>
</template>
<script>
export default {
    data(){
        return{
            password:"",
            newpassword:"",
            repassword:"",
            proccess:false
        }
    },
    computed:{
        user(){
            return this.$store.getters.user;
        }
    },
    methods:{
        notification(type,message){
            this.$notify({
                    group: 'foo',
                    title: 'Important message',
                    text: message,
                    duration:5000, 
                    type:type               
            })
        },
        reset(){
        let vm = this;
        if(vm.password=="") return vm.notification("error","Old Password Required")
        if(vm.newpassword=="") return vm.notification("error","New Password Required")
        if(vm.repassword=="") return vm.notification("error","Confirm Password Required")
        if(vm.newpassword.length<6) return vm.notification("error","Password length must be above 6")                        
        if(vm.newpassword!=vm.repassword) return vm.notification("error","Password must be same")                        
          let doc = {
                'MobileNo':vm.user.phone,
                'Password':vm.password,
                'NewPassword':vm.newpassword,
                'AuthKey':vm.user.authkey,
                'Source':'json'
                }
            vm.proccess= true;
            vm.$store.dispatch("axiospost",{
                    url:"changePassword",
                    data:doc,
            }).then(function (res) {
                    vm.proccess = false;
                    console.log(res);                    
                    if(res.data.Status=="False"){
                        return vm.notification("error",res.data.Message);
                    }                                
                    if(res.data.Status=="Success") {                                        
                            vm.proccess = false;
                            let doc = vm.user;
                            doc.password = vm.newpassword;
                            localStorage.user = JSON.stringify(doc);
                            vm.$store.dispatch("getuser");
                            console.log(localStorage.user);                                        
                            vm.password = ""
                            vm.newpassword = ""
                            vm.repassword = ""
                            return vm.notification("success","Password Reset Success")

                    }
            }).catch(function (error) {
                    vm.notification("error",error);
                    vm.proccess = false;
                    
            })
        }

    }
}
</script>
